import { useGetBankManagement } from "../../api/bank";

export const useBankManagement = (
  params: { start: number; end: number },
  name?: string,
  country?: string
) => {
  const {
    data = {
      data: {
        data: { total: 0, pageSize: 10, page: 1, totalPages: 1, items: [] },
      },
    },
    isLoading,
    refetch,
  } = useGetBankManagement({
    ...params,
    name,
    country,
  });
  return { dataBankManagement: data.data, isLoading, refetch };
};
